import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { productOfferingsQuery, productsQuery } from '../../../../data/service.ts'
import { SubscriptionForm } from '../../../../features/serviceManagement/accounts/SubscriptionForm.tsx'

export const Route = createFileRoute('/_app/smp/accounts/$customerId/$subscriptionId/edit')({
	component: RouteComponent,
	loader: async ({ context: { customers, queryClient }, params }) => {
		await queryClient.ensureQueryData(productOfferingsQuery)
		const customer = customers.find((customer) => customer.id === params.customerId)
		if (!customer) {
			throw redirect({ to: '/smp/accounts' })
		}
		await queryClient.ensureQueryData(productsQuery)
		return { customer }
	},
})

function RouteComponent() {
	const { customer } = Route.useLoaderData()
	const { subscriptionId } = Route.useParams()
	const { data: products } = useSuspenseQuery(productsQuery)
	const product = products.find((p) => p.id === subscriptionId)
	if (!product) {
		throw redirect({ to: '/smp/accounts/$customerId', params: { customerId: customer.id } })
	}
	return <SubscriptionForm key={product.id} product={product} customer={customer} />
}
